import { connect } from 'react-redux';
import React, { Component } from 'react';
import routerActions from 'app/routerActions';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import ReactDOM from 'react-dom';
import { Field, FieldArray, formValueSelector, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import {
reservationsActions,
successState,
apiCallFailure,
orgActions } from
'app/actions';
import * as valid from 'utils/validate';
import { api, apiUtils } from 'app/services';
import * as selectors from 'app/selectors';
import {
KBInput,
KBPopover,
KBFormError,
KBSelect,
KBButton,
KBUserInput,
KBDateInput,
KBRangeDate,
KBTextarea,
KBMorePhotoUpload,
KBMoreFileUpload } from
'components';
import dayjs from 'utils/dayjs';
import { DAY_TIME_HM } from 'app/constants';
import { getMeetingInitData } from 'utils/kbData';
import {
renderKBInput,
renderKBSelect,
renderKBTextarea,
renderKBUserInput,
toKBArrayField } from
'components/formAdapters/reduxFormAdapters';

const PAYMENT_TYPES = [
{ id: 'temporary_booking', name: '临时代订' },
{ id: 'own_use', name: '中心自用' },
{ id: 'special_booking', name: '特殊预订' }];

const renderKBMoreFileUpload = ({ fields }) => (
  <KBMoreFileUpload
  uploadingText="正在上传"
  uploadedText="点击上传"
  sort={false}
  multiple
  className="kb-form-group kb-form-alone"
  field={toKBArrayField(fields)}
  text="上传附件"
  accept=".pdf,.png,.jpg,.jpeg"
  title="附件格式为PDF、PNG、JPG、JPEG，可上传多个附件"
  fileType="attachments" />
);


var MeetingBookingForm = class extends React.Component {constructor(props) {super(props);this.state = this.getInitialState();this.reservationsRoom = this.reservationsRoom.bind(this);this.parseHM = this.parseHM.bind(this);this.loadOrgs = this.loadOrgs.bind(this);this.orgCallBack = this.orgCallBack.bind(this);this.onInputChange = this.onInputChange.bind(this);this.memberCallBack = this.memberCallBack.bind(this);this.setYMD = this.setYMD.bind(this);this.setHM = this.setHM.bind(this);this.changeYMDCallback = this.changeYMDCallback.bind(this);this.changeStartHMCallback = this.changeStartHMCallback.bind(this);this.changeEndHMCallback = this.changeEndHMCallback.bind(this);this.changeDate = this.changeDate.bind(this);this.setDateTimeRangeField = this.setDateTimeRangeField.bind(this);}getInitialState()
  {
    const { start_at, end_at } = this.props;
    return {
      orgId: null,
      members: [],
      name: null,
      phone: null,
      from: start_at && dayjs(start_at).format('YYYY-MM-DD') || null,
      to: end_at && dayjs(end_at).format('YYYY-MM-DD') || null };

  }reservationsRoom(

  model) {
    const {
      meeting,
      createReservationsAction,
      callback,
      successAction } =
    this.props;
    model.meeting_room_id = meeting.id;

    delete model.startHM;
    delete model.endHM;
    delete model.start_at;
    delete model.end_at;
    delete model.organization_id;

    if (!model.sales_customer_id) {
      delete model.sales_customer_id;
    }

    if (!model.contacts_id) {
      delete model.contacts_id;
    }

    if (model.contacts_phone && model.contacts_phone.includes('*')) {
      delete model.contacts_phone;
    }

    if (model.payment_type) {
      model.mixed_payments = [model.payment_type];
    }

    if (model.attachments && model.attachments.length) {
      model.attachments = model.attachments.map(i => i.url);
    }

    return api.createReservations(model).then(
    json => {
      successAction({ message: `${meeting.name} 预约成功!` });
      createReservationsAction.success(json);
      callback && callback();
      KBPopover.close();
      return true;
    },
    error => {
      createReservationsAction.failure(error);
    });

  }componentDidMount()

  {
    const {
      change,
      meeting } =
    this.props;
    const currentStartAt = this.props.start_at;
    const currentEndAt = this.props.end_at;
    const orderOption = meeting && meeting.order_option;
    let s = this.parseHM(currentStartAt);
    let e = this.parseHM(currentEndAt);
    //  orderOption === 'by_day' ? startHM.onChange('0,1'): startHM.onChange(s)
    //  orderOption === 'by_day' ? endHM.onChange('24,1'): endHM.onChange(e)
    change('startHM', orderOption === 'by_day' ? '00:00' : s);
    change('endHM', orderOption === 'by_day' ? '23:59' : e);
    this.setHM('start_at', s, currentStartAt);
    this.setHM('end_at', e, currentEndAt);

    // if (
    //   !(
    //     orgs &&
    //     orgs.length &&
    //     orgs[orgs.length - 1] &&
    //     orgs[orgs.length - 1].id
    //   )
    // ) {
    this.loadOrgs();
    // }
  }parseHM(

  date) {
    let hours = date.get('hour');
    let minute = date.get('minute');
    let t = '1';
    let h = hours;
    if (minute == 30) {
      t = '2';
    } else {
      t = '1';
    }

    return h + ',' + t;
  }loadOrgs()

  {
    const { getOrganizationsAction, loc_id } = this.props;
    api.
    getOrganizations({
      location_id: loc_id,
      per_page: 1000,
      includes: 'details',
      organization_type: 'normal' }).

    then(
    json => {
      getOrganizationsAction.success(json);
    },
    errors => {
      getOrganizationsAction.failure(errors);
    });

  }orgCallBack(

  org) {
    const { loc_id } = this.props;
    const {
      change } =
    this.props;

    if (!org.id) {
      this.setState({
        members: [] });

      return null;
    }

    this.setState({
      orgId: org.id },
    () => {
      this.onInputChange();
    });

    api.
    getOrganizationInfo(org.id, {
      location_id: loc_id,
      includes: 'details' }).

    then(json => {
      let detailedOrg = json.response.body;
      detailedOrg.sales_customer &&
      change('sales_customer_id', detailedOrg.sales_customer.id);
      // api
      //   .getUsers({
      //     organization_id: org.id,
      //     includes: 'space_users',
      //     per_page: 200,
      //   })
      //   .then(json => {
      //     this.setState({
      //       members: json.response.body
      //     })
      //     contacts_id.onChange(null)
      //   })
    });
  }onInputChange(

  name) {
    const {
      change } =
    this.props;
    if (!this.state.orgId) {
      return;
    }
    api.
    getUsers({
      organization_id: this.state.orgId,
      includes: 'space_users',
      per_page: 999,
      name }).

    then(json => {
      this.setState({
        members: json.response.body });

      change('contacts_id', null);
    });
  }memberCallBack(

  member) {
    const { name, phone_num, phone_num_disabled } = member;
    const {
      change } =
    this.props;

    if (name && name.indexOf('*') == -1) {
      change('contacts_name', name);
    }

    if (phone_num) {
      if (phone_num_disabled == true) {
        change('contacts_phone', '您的电话号处于挂失状态');
      } else {
        change('contacts_phone', phone_num);
      }
    }
  }setYMD(

  fieldName, value, fieldValue) {
    const { change } = this.props;
    let date = dayjs(value);

    let year = date.get('year');
    let month = date.get('month');
    let day = date.get('date');
    change(
    fieldName,
    dayjs(fieldValue).
    clone().
    set({ year, month, date: day }).
    toDate());

  }setHM(

  fieldName, value, fieldValue) {
    const { change } = this.props;
    let t = value.split(',');
    change(
    fieldName,
    dayjs(fieldValue).
    clone().
    set({ hour: t[0], minute: t[1] == '1' ? 0 : 30, second: 0 }).
    toDate());

    setTimeout(
    this.changeDate.bind(null, { from: this.state.from, to: this.state.to }),
    50);

  }changeYMDCallback(

  date) {
    const {
      startAtValue,
      endAtValue } =
    this.props;
    this.setYMD('start_at', date, startAtValue);
    this.setYMD('end_at', date, endAtValue);
  }changeStartHMCallback(

  data) {
    const {
      startAtValue } =
    this.props;
    this.setHM('start_at', data, startAtValue);
  }changeEndHMCallback(

  data) {
    const {
      endAtValue } =
    this.props;
    this.setHM('end_at', data, endAtValue);
  }changeDate(

  range) {
    const {
      startAtValue,
      endAtValue,
      apiCallFailureAction } =
    this.props;
    if (!(range.from && range.to)) {
      return apiCallFailureAction({
        status: 'error',
        message: '请选择预订结束日期' });

    }
    let timeRange = {
      start_at: startAtValue,
      end_at: endAtValue };

    this.setDateTimeRangeField(range, timeRange);
    this.setState({
      from: range.from,
      to: range.to });

  }setDateTimeRangeField(

  dateRange, timeRange) {
    const {
      change,
      meeting } =
    this.props;
    const orderOption = meeting && meeting.order_option;
    let start_date = dayjs(dateRange.from).format('YYYY-MM-DD');
    let end_date = dayjs(dateRange.to).format('YYYY-MM-DD');
    let start_time =
    orderOption === 'by_day' ?
    '00:00' :
    dayjs(timeRange.start_at).format('HH:mm');
    let end_time =
    orderOption === 'by_day' ?
    '23:59' :
    dayjs(timeRange.end_at).format('HH:mm');
    let dates_in_range = [];
    let currentDate = start_date;
    while (dayjs(currentDate).isBefore(end_date)) {
      dates_in_range.push(currentDate);
      currentDate = dayjs(currentDate).
      add(1, 'days').
      format('YYYY-MM-DD');
    }
    dates_in_range.push(end_date);
    change('timespan', dates_in_range.map(date => ({
        start_at: date + ' ' + start_time,
        end_at: date + ' ' + end_time })));
  }render()

  {
    const {
      orgs,
      submitting,
      handleSubmit,
      meeting,
      DEAL_DAY_TIME_HM } =
    this.props;
    const { members, from, to } = this.state;
    var halfClass = {
      className: 'kb-form-group kb-div-c39' };

    const orderOption = meeting && meeting.order_option;

    return (
      <form onSubmit={handleSubmit(this.reservationsRoom)}>
        <KBFormError error={this.props.error} />
        <header className="kb-form-header">
          <div className="header-title">
            预约<span style={{ marginLeft: 5 }}>{meeting.name}</span>
          </div>
          <i
          className="iconfont header-close icon-cancel"
          onClick={KBPopover.close} />

        </header>
        <div className="kb-form-container">
          <div className="kb-row">
            <div className="kb-form-c18 kb-form-group kb-form-alone">
              <label>
                预订日期<span className="must-fill">*</span>
              </label>
              <div>
                <KBRangeDate
                format="YYYY/MM/DD"
                from={from || ''}
                to={to || ''}
                callback={this.changeDate}
                leftNone={true} />

              </div>
              <p style={{ color: '#c8c8c8', fontSize: 12 }}>
                当预订日期超过一天，则将会在日期内的每一天预订同一时间段
              </p>
            </div>
          </div>
          {orderOption === 'by_day' ?
          <div className="kb-row kb-form-66">
              {/* <KBSelect title='开始' isRequired={ true } arrayData={ DEAL_DAY_TIME_HM } field={startHM} {...halfClass} disabled={true} /> */}
              <Field
            name="startHM"
            component={renderKBInput}
            disabled={true}
            isRequiredR={true}
            title="开始"
            className="kb-form-group kb-div-c48"
            inputClass=" kb-input kb-input-disabled" />

              {/* <KBSelect title='结束' isRequiredR={ true } titleClass='label-rt' arrayData={ DEAL_DAY_TIME_HM } field={endHM} {...halfClass}disabled={true} /> */}
              <Field
            name="endHM"
            component={renderKBInput}
            disabled={true}
            isRequiredR={true}
            title="结束"
            className="kb-form-group kb-div-c48"
            inputClass=" kb-input kb-input-disabled" />

            </div> :

          <div className="kb-row kb-form-66">
              <Field
            name="startHM"
            component={renderKBSelect}
            title="开始"
            isRequired={true}
            onChange={this.changeStartHMCallback}
            arrayData={DEAL_DAY_TIME_HM}
            {...halfClass} />

              <Field
            name="endHM"
            component={renderKBSelect}
            title="结束"
            isRequiredR={true}
            onChange={this.changeEndHMCallback}
            titleClass="label-rt"
            arrayData={DEAL_DAY_TIME_HM}
            {...halfClass} />

            </div>}


          {/* 预定情况 */}
          <div>
            <div className="kb-row">
              <Field
              name="payment_type"
              component={renderKBSelect}
              className="kb-form-group kb-form-c18 kb-form-alone"
              title="预定情况"
              isRequired
              defaultValue="-1"
              arrayData={PAYMENT_TYPES}
              defa />

            </div>
            <div className="kb-row">
              <Field
              name="remark"
              component={renderKBTextarea}
              className="kb-form-group kb-form-c18 kb-form-alone"
              title="备注"
              isRequired />

            </div>
          <div className="kb-row">
            <FieldArray
            name="attachments"
            component={renderKBMoreFileUpload} />

          </div>
          </div>

          {
          // meeting.area_type != 'meeting_room' ? null :
          <div className="kb-row">
              <Field
            name="organization_id"
            component={renderKBUserInput}
            title="公司"
            hint="可以选择公司，来宾请直接输入姓名和电话"
            callback={this.orgCallBack}
            placeholder={'请选择公司'}
            className="kb-form-c18 kb-form-group kb-form-alone"
            multi={false}
            users={orgs} />

            </div>}

          <div className="kb-row">
            <Field
            name="contacts_id"
            component={renderKBUserInput}
            title="员工"
            callback={this.memberCallBack}
            className="kb-form-c18 kb-form-group kb-form-alone"
            multi={false}
            users={members} />

          </div>
          <div className="kb-row">
            <Field
            name="contacts_name"
            component={renderKBInput}
            title="联系人"
            isRequired={true}
            className="kb-form-c18 kb-form-group kb-form-alone" />

          </div>
          <div className="kb-row">
            <Field
            name="contacts_phone"
            component={renderKBInput}
            title="联系电话"
            isRequired={true}
            className="kb-form-c18 kb-form-group kb-form-alone" />

          </div>

          <div className="kb-row fixed-form-btn">
            <span className="cancel-btn" onClick={KBPopover.close}>
              取消
            </span>
            <KBButton
            className="certain-btn"
            type="submit"
            submitting={submitting}>

              确定
            </KBButton>
          </div>
        </div>
      </form>);

  }};


function mapStateToProps(state, props) {
  const selector = formValueSelector('MeetingForm');
  let reservation_time_range = props.reservation_time_range;
  const { begin, end } = reservation_time_range;
  let DEAL_DAY_TIME_HM = DAY_TIME_HM(begin || 0, end || 24);
  let loc_id = props.loc_id;
  const orgs = selectors.getOrgsOfLocation(state, loc_id);
  orgs.unshift({ name: '请选择', id: null });

  return {
    orgs,
    state,
    loc_id,
    startAtValue: selector(state, 'start_at'),
    endAtValue: selector(state, 'end_at'),
    DEAL_DAY_TIME_HM };

}

function mapDispatchToProps(dispatch) {
  return {
    createReservationsAction: bindActionCreators(
    reservationsActions.create,
    dispatch),

    successAction: bindActionCreators(successState, dispatch),
    apiCallFailureAction: bindActionCreators(apiCallFailure, dispatch),
    getOrganizationsAction: bindActionCreators(orgActions.replace, dispatch) };

}

const validate = values => {
  const errors = {};

  const getHMMinutes = value => {
    if (!value || typeof value !== 'string') {
      return null;
    }

    const [hour, half] = value.split(',').map(Number);
    if (!Number.isFinite(hour) || !Number.isFinite(half)) {
      return null;
    }

    return hour * 60 + (half === 2 ? 30 : 0);
  };

  if (valid.required(values.startHM)) {
    errors.startHM = '请选择开始时间';
  }

  if (valid.required(values.endHM)) {
    errors.endHM = '请选择结束时间';
  }

  if (valid.required(values.contacts_name)) {
    errors.contacts_name = '请输入联系人名称';
  }

  if (valid.required(values.remark)) {
    errors.remark = '请输入备注';
  }

  if (valid.required(values.payment_type)) {
    errors.payment_type = '请选择预定情况';
  }

  if (valid.required(values.contacts_phone)) {
    errors.contacts_phone = '请输入联系电话';
  }

  if (
  valid.mobile(values.contacts_phone) &&
  values.contacts_phone &&
  !values.contacts_phone.includes('*'))
  {
    errors.contacts_phone = '请输入正确的联系电话';
  }

  const startHMMinutes = getHMMinutes(values.startHM);
  const endHMMinutes = getHMMinutes(values.endHM);
  const duration = startHMMinutes !== null && endHMMinutes !== null ?
  endHMMinutes - startHMMinutes :
  dayjs(values.end_at).diff(dayjs(values.start_at), 'minutes');

  if (duration < 30) {
    errors.startHM = '预订时长必须大于30分钟';
  }

  return errors;
};

const formConfig = {
  form: 'MeetingForm',
  validate: validate,
  touchOnBlur: false };


MeetingBookingForm.propTypes = {
  loc_id: PropTypes.string.isRequired,
  meeting: PropTypes.object.isRequired,
  end_at: PropTypes.object.isRequired,
  start_at: PropTypes.object.isRequired,
  callback: PropTypes.func };


MeetingBookingForm = connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(MeetingBookingForm));

export default MeetingBookingForm;
